import React, { useCallback, memo } from 'react';
import PropTypes from 'prop-types';
import { colors } from '@constants/colors';
import { Icon } from '@mui';
import { getGroupIcon } from '@utils/icon-utils';
import NewBaseListItem from './base-list-item';
import './list-item.scss';

const GroupListItem = ({ name, onClick, onMouseEnter, onMouseLeave, ...otherProps }) => {
  const renderTypeIcon = useCallback(() => (
    <div styleName="icon type-icon">
      <Icon
        color={colors.opacity.black0_6}
        aria-hidden="true"
        style={{ fontSize: 16 }}
      >
        group_work
      </Icon>
    </div>
  ), []);

  return (
    <NewBaseListItem
      {...otherProps}
      name={name}
      entityTypeName="group"
      headerIcon={getGroupIcon()}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      renderContent={() => null}
      renderFooter={() => null}
      renderTypeIcon={renderTypeIcon}
      titleName={name}
    />
  );
};

GroupListItem.propTypes = {
  name: PropTypes.string,
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func
};

export default memo(GroupListItem);
